module.exports = __webpack_public_path__ + "static/parker-coulter-logo-da23096c5b5bf83ca6f2c79a233a9140.png";